import { createFileRoute } from "@tanstack/react-router";

import { FreshMatchesPage } from "@/features/fresh-matches";

// «Матчи сразу»: экран целиком из фичи `fresh-matches`.
export const Route = createFileRoute("/fresh-matches")({
  component: FreshMatchesPage,
});
